module.exports = __webpack_public_path__ + "img/bytwxf01-ico.aa1c1015.png";